import './style.scss';

(() => {
  function toggleDropdownIcon(downTargetId, upTargetId) {
    const upIcon = $('#' + upTargetId);
    const downIcon = $('#' + downTargetId);

    return function (open = false) {
      if (open) {
        upIcon.css('display', 'inline-flex');
        downIcon.css('display', 'none');
      } else {
        upIcon.css('display', 'none');
        downIcon.css('display', '');
      }
    };
  }

  function transactionViewListDropdown() {
    const dropdown = $('#transaction-view-list-dropdown');
    const button = $('#transaction-view-list-dropdown-btn');
    const dropdownInstance = toggleDropdownIcon(
      'transaction-view-dropdown-icon-down',
      'transaction-view-dropdown-icon-up'
    );

    button.hover(
      function () {
        dropdown.css('display', 'block');
        dropdownInstance(true);
      },
      function () {
        dropdown.css('display', '');
        dropdownInstance(false);
      }
    );
    dropdown.hover(
      function () {
        dropdown.css('display', 'block');
        dropdownInstance(true);
      },
      function () {
        dropdown.css('display', '');
        dropdownInstance(false);
      }
    );
  }

  function attachTransactionStatus() {
    $('.o2i-transactions-container[data-class]').each(function () {
      const dynamicClass = $(this).data('class')?.toLowerCase();
      if (dynamicClass) {
        $(this).addClass('transaction-' + dynamicClass);
      }
    });
  }

  function syncTransactionHeaderAndDataScroll() {
    const $childContent = $('#o2i-transactions-data');
    const $childFixed = $('#o2i-transactions-header');

    $childContent.on('scroll', function () {
      $childFixed.scrollLeft($childContent.scrollLeft());
    });

    function setHeaderWidth() {
      const childWidth = $childContent.width();
      $childFixed.width(childWidth);
    }

    setHeaderWidth();
    $(globalThis).on('resize', function () {
      setHeaderWidth();
    });
  }

  function downloadCSV() {
    $('#o2i-download-csv').on('click', function () {
      const link = document.createElement('a');
      link.href = 'https://assets.e5.ai/demo/o2i/transactions.zip';
      link.download = 'transactions.zip';
      document.body.append(link);
      link.click();
      link.remove();
    });
  }

  function enableSidebarToggler() {
    $('#process-collapse, #process-expand').on('click', function () {
      $('#process-collapse').toggle();
      $('#process-expand').toggle();
      $('.main-container').toggleClass('collapsed');
    });
  }

  function registerDrawerCloseClick() {
    $('#e5-drawer-close').on('click', function () {
      $('#e5-drawer').hide();
    });
  }

  function registerTransactionRowClick() {
    $('#o2i-transactions-data .o2i-transactions-container').on('click', function () {
      const transaction = $(this).data('transaction');
      const { inputTab, outputTab } = transaction || {};

      if (inputTab) {
        const { facilityId, branchCodes, patientName, episodeId, patientMrNo } = inputTab;
        const {
          validationStatus,
          submissionId,
          messageNumberSeverity,
          addCoordinationNotesStatus,
          m0090Date,
          visitDate,
        } = outputTab;

        // Input
        $('#e5-drawer-title').text(patientName);
        $('#e5-transaction-input-facility-id').text(facilityId);
        $('#e5-transaction-input-branch-codes').text(branchCodes);
        $('#e5-transaction-input-patient-name').text(patientName);
        $('#e5-transaction-input-episode-id').text(episodeId);
        $('#e5-transaction-input-mrn').text(patientMrNo);

        // Result
        $('#e5-transaction-result-validation-status').text(validationStatus);
        $('#e5-transaction-result-submission-id').text(submissionId);
        $('#e5-transaction-result-msg-severity').text(messageNumberSeverity);
        $('#e5-transaction-result-notes').text(addCoordinationNotesStatus);
        $('#e5-transaction-result-m0090-date').text(m0090Date);
        $('#e5-transaction-result-visit-date').text(visitDate);

        $('#e5-drawer').show();
      } else {
        $('#e5-drawer').hide();
      }
    });
  }

  if (globalThis.location.pathname === '/oasis-to-iqies-2-0') {
    $(document).ready(function () {
      transactionViewListDropdown();
      attachTransactionStatus();
      syncTransactionHeaderAndDataScroll();
      downloadCSV();
      enableSidebarToggler();
      registerDrawerCloseClick();
      registerTransactionRowClick();
    });
  }
})();
